import { render, staticRenderFns } from "./ServiceContract.vue?vue&type=template&id=f19f869e&scoped=true&"
import script from "./ServiceContract.vue?vue&type=script&lang=js&"
export * from "./ServiceContract.vue?vue&type=script&lang=js&"
import style0 from "./ServiceContract.vue?vue&type=style&index=0&id=f19f869e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19f869e",
  null
  
)

export default component.exports